<template>
  <main class="container order-checkout">
    <mt-field label="订单编号" :placeholder="orderNumber" :readonly="true"></mt-field>
    <mt-field label="收货人号码" :placeholder="phoneNumber | phoneEncode" :readonly="true">
      <span class="send-number" @click="getValidateCode">{{ validataCodeTxt }}</span>
    </mt-field>
    <mt-field label="验证码" placeholder="请输入验证码" v-model="inputCodeValue" @blur="validateCodeBlur" type="tel"></mt-field>
    <button class="submit-btn" @click="register">提交</button>
  </main>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { UserRegister, GetTelCode } from '@/api/login'
import { mapMutations, mapGetters } from 'vuex'
export default {
  data() {
    return {
      // 电话号码
      phoneNumber: '18219111803',
      orderNumber: '',
      inputCodeValue: '',
      countDownTime: 0,
      validataCodeTxt: '发送验证码',
      timer: null
    }
  },
  mounted() {
    this.phoneNumber = this.$route.query.phoneNum
    this.orderNumber = this.$route.query.orderNum
  },
  computed: {
    ...mapGetters(['sessionId'])
  },
  methods: {
    ...mapMutations(['RECEIVE_SESSION_ID', 'RECEIVE_LOGIN_STATE']),
    // 倒计时
    countDown() {
      this.countDownTime = this.countDownTime - 1
      this.validataCodeTxt = this.countDownTime + 's后获取'
      if (this.countDownTime <= 0) {
        this.validataCodeTxt = '重新获取'
        clearInterval(this.timer)
      }
    },
    // 获取验证码
    getValidateCode: function() {
      if (this.countDownTime) return
      this.countDownTime = 60
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      GetTelCode({ Tel: this.phoneNumber })
        .then((res) => {
          if (res) {
            if (res.Msg) {
              Toast({
                message: '验证码已发送',
                position: 'bottom'
              })
              this.timer = setInterval(this.countDown, 1000)
            }
          }
          Indicator.close()
        })
        .catch((err) => {
          Toast(err.ErrMsg)
          this.countDownTime = 0
          Indicator.close()
        })
    },
    // 注册
    register() {
      if (this.inputCodeValue.length < 6) {
        Toast({
          message: '验证码不能小于',
          position: 'bottom'
        })
        return
      }
      let params = {
        TelCode: this.inputCodeValue,
        Tel: this.phoneNumber,
        tokenid: this.sessionId
      }
      UserRegister(params)
        .then((res) => {
          this.RECEIVE_SESSION_ID(res.Data.tokenid)
          this.RECEIVE_LOGIN_STATE(res.Data.isLogin)
          this.$router.replace({
            name: 'luckdraw',
            query: {
              orderNum: this.orderNumber
            }
          })
        })
        .catch((err) => {
          Toast({
            message: err.ErrMsg,
            position: 'bottom'
          })
        })
    },
    validateCodeBlur() {
      setTimeout(function() {
        window.scrollTo(0, 0)
      }, 100)
    }
  },
  filters: {
    phoneEncode(val) {
      if (!val) {
        return '----'
      }
      let star = val.substring(0, 3)
      let end = val.substring(val.length - 4, val.length)
      return star + '****' + end
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #fff;
}
.order-checkout >>> .mint-cell-wrapper {
  font-size: 14px;
}
.order-checkout >>> .mint-cell-value input {
  text-align: right;
}
.order-checkout .send-number {
  margin-left: 12px;
  background: #409fff;
  color: #fff;
  display: inline-block;
  height: 30px;
  line-height: 30px;
  padding: 0 6px;
  font-size: 12px;
  box-shadow: 0 2px 10px 0 #999;
  border-radius: 2px;
}
.order-checkout .submit-btn {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 50px;
  line-height: 50px;
  display: block;
  background: #409fff;
  color: #fff;
}
.order-checkout .submit-btn:hover {
  opacity: 0.9;
}
</style>
